import type { SakhtarIconName } from '@sakhtar/design-system/react';
import type { BrandColor, SidebarSkin, ThemeMode } from '../../lib/types/membership.js';
/** Presentation-only constants for the First Login Profile wizard's avatar
 * presets, brand colors, theme modes and sidebar skins — ids are the only
 * part stored server-side (`OwnProfileResponse`/`OwnProfilePatchBody`); the
 * gradient colors/icons/labels below exist only to render the picker and
 * mirror `Sakhtar First Login Profile.dc.html`'s own constants exactly. */

// Avatar presets are shared with the shell (topbar, bottom nav, drawer).
export { AVATAR_PRESET_DEFS, avatarGradient, type AvatarPresetDef } from '../../lib/avatars.js';

export interface BrandColorDef {
  readonly id: BrandColor;
  readonly label: string;
  readonly color: string;
}

export const BRAND_COLOR_DEFS: readonly BrandColorDef[] = [
  { id: 'indigo', label: 'نیلی', color: 'oklch(55% 0.19 264)' },
  { id: 'emerald', label: 'زمردی', color: 'oklch(55% 0.15 165)' },
  { id: 'ruby', label: 'یاقوتی', color: 'oklch(55% 0.19 18)' },
  { id: 'amber', label: 'کهربایی', color: 'oklch(62% 0.16 75)' },
  { id: 'violet', label: 'بنفش', color: 'oklch(55% 0.20 295)' },
  { id: 'slate', label: 'نقره‌ای', color: 'oklch(45% 0.06 240)' },
];

export interface ThemeModeDef {
  readonly id: ThemeMode;
  readonly label: string;
  readonly icon: SakhtarIconName;
  readonly hint: string;
}

export const THEME_MODE_DEFS: readonly ThemeModeDef[] = [
  { id: 'light', label: 'روشن', icon: 'sun', hint: 'پیش‌فرض — مناسب محیط پرنور' },
  { id: 'dark', label: 'تاریک', icon: 'moon', hint: 'مناسب کار شبانه' },
  { id: 'system', label: 'هماهنگ با دستگاه', icon: 'globe', hint: 'طبق تنظیمات سیستم شما' },
];

export interface SidebarSkinDef {
  readonly id: SidebarSkin;
  readonly label: string;
  readonly bg: string;
}

export const SIDEBAR_SKIN_DEFS: readonly SidebarSkinDef[] = [
  { id: 'brand', label: 'برند', bg: 'var(--sk-brand-700)' },
  { id: 'brand-deep', label: 'برند تیره', bg: 'var(--sk-brand-900)' },
  { id: 'ink', label: 'مشکی', bg: '#0e1118' },
  { id: 'surface', label: 'روشن', bg: 'var(--sk-bg-elev)' },
];

export const JALALI_MONTH_NAMES = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

/** Last 51 Jalali years, newest first — matches the design's own range (a
 * birthdate range, not a general date picker). */
export function birthYearOptions(currentJy: number): readonly number[] {
  return Array.from({ length: 51 }, (_, i) => currentJy - i);
}
